import { Ref, useImperativeHandle } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "../CreatorFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import {
  getArticleFieldFromVisibility,
  RELATED_TASKS_ARTICLE_PATH,
  RelatedTasksComponent,
  RelatedTasksConfigProps,
} from "../../../RelatedTasks/RelatedTasksComponent";
import { safeGetByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { shouldShowField } from "@coworker/apprestructured/src/task-management/helpers/visibilityCondition.helper";

type Props = {
  configProps: RelatedTasksConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function RelatedTasksCreatorFragment({ commonProps, configProps, ref }: Props) {
  useImperativeHandle(ref, () => ({ valid: true }));

  if (isLoading(commonProps.taskType)) return null;
  if (
    configProps.visibility &&
    !isLoading(commonProps.task) &&
    !shouldShowField(commonProps.task, configProps.visibility)
  ) {
    return null;
  }

  if (!isLoading(commonProps.task)) {
    const articleField =
      getArticleFieldFromVisibility(configProps.visibility) ||
      RELATED_TASKS_ARTICLE_PATH;
    const articleNo = safeGetByPath(commonProps.task, articleField);

    if (typeof articleNo !== "string" || !articleNo.trim()) {
      return null;
    }
  }

  return (
    <RelatedTasksComponent
      task={commonProps.task}
      taskTypeId={commonProps.taskType.id}
      fields={configProps}
    />
  );
}

export default RelatedTasksCreatorFragment;
